<template>
  <i18n-t :keypath="keypath" scope="global">
    <template #name>{{ name }}</template>

    <template #remaining>
      <span :class="countClass">{{ remaining }}</span>
    </template>
  </i18n-t>
</template>

<script lang="ts" setup>
type Props = {
  countClass?: string
  keypath: string
  name: string
  remaining: number
}

defineProps<Props>()
</script>
